import { ICreateSendShipmentInfoState } from '../types/createSendShipmentInfo';

export const DEFAULT_CREATE_SEND_SHIPMENT_INFO_STATE: ICreateSendShipmentInfoState = {
  form: {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    company: '',
    country: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
  },
  selectedAddressId: null,
  addressApplied: false,
};
